import PropTypes from 'prop-types';

function deprecated(propTypeValidation, version) {
  var isDeprecated = function isDeprecated(props, deprecatedPropName, componentName) {
    if (props[deprecatedPropName] && process.env.NODE_ENV !== 'production') {
      console.warn("DeprecationWarning: The \"".concat(deprecatedPropName, "\" prop on ").concat(componentName, " has been deprecated in ").concat(version, "\n        and will be removed in future releases. Look at the stories for ").concat(componentName, " for more info."));
    }
  };
  return PropTypes.oneOfType([isDeprecated, propTypeValidation]);
}

export { deprecated as default };
//# sourceMappingURL=deprecated.js.map
